<template>
  <thematic-results page-type="collections" />
</template>
